/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Nohraclinic API
 * API do Nohraclinic. Sessão web por cookie httpOnly; mobile por bearer. As rotas sob /v1/auth/* que não estão aqui são servidas pelo handler do better-auth, restrito a uma allowlist (ver src/modules/auth/auth.mount.ts): sign-in/email, sign-out, get-session, verify-email, send-verification-email, request-password-reset e reset-password. O cadastro entra só por POST /v1/auth/registro.
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AtualizarCupomDto,
  CriarCupomDto,
  CupomDetalheResponse,
  CupomResponse,
  CuponsControllerEnviarImagemBody,
  CuponsControllerListarParams,
  DefinirAtivoCupomDto,
  ErroResponse,
  PaginaDeCuponsResponse
} from '../model';

import { httpClient } from '../../http-client.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getCuponsControllerListarUrl = (params?: CuponsControllerListarParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/admin/cupons?${stringifiedParams}` : `/v1/admin/cupons`
}

/**
 * @summary Lista os cupons, paginado. `regras` NÃO vem aqui.
 */
export const cuponsControllerListar = async (params?: CuponsControllerListarParams, options?: Parameters<typeof httpClient>[1]): Promise<PaginaDeCuponsResponse> => {

  return httpClient<PaginaDeCuponsResponse>(getCuponsControllerListarUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getCuponsControllerListarQueryKey = (params?: CuponsControllerListarParams,) => {
    return [
    `/v1/admin/cupons`, ...(params ? [params] : [])
    ] as const;
    }


export const getCuponsControllerListarQueryOptions = <TData = Awaited<ReturnType<typeof cuponsControllerListar>>, TError = ErroResponse>(params?: CuponsControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cuponsControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCuponsControllerListarQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof cuponsControllerListar>>> = ({ signal }) => cuponsControllerListar(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof cuponsControllerListar>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CuponsControllerListarQueryResult = NonNullable<Awaited<ReturnType<typeof cuponsControllerListar>>>
export type CuponsControllerListarQueryError = ErroResponse


export function useCuponsControllerListar<TData = Awaited<ReturnType<typeof cuponsControllerListar>>, TError = ErroResponse>(
 params: undefined |  CuponsControllerListarParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof cuponsControllerListar>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof cuponsControllerListar>>,
          TError,
          Awaited<ReturnType<typeof cuponsControllerListar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCuponsControllerListar<TData = Awaited<ReturnType<typeof cuponsControllerListar>>, TError = ErroResponse>(
 params?: CuponsControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cuponsControllerListar>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof cuponsControllerListar>>,
          TError,
          Awaited<ReturnType<typeof cuponsControllerListar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCuponsControllerListar<TData = Awaited<ReturnType<typeof cuponsControllerListar>>, TError = ErroResponse>(
 params?: CuponsControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cuponsControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista os cupons, paginado. `regras` NÃO vem aqui.
 */

export function useCuponsControllerListar<TData = Awaited<ReturnType<typeof cuponsControllerListar>>, TError = ErroResponse>(
 params?: CuponsControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cuponsControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCuponsControllerListarQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCuponsControllerCriarUrl = () => {




  return `/v1/admin/cupons`
}

/**
 * @summary Cria um cupom
 */
export const cuponsControllerCriar = async (criarCupomDto: CriarCupomDto, options?: Parameters<typeof httpClient>[1]): Promise<CupomResponse> => {

  return httpClient<CupomResponse>(getCuponsControllerCriarUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(criarCupomDto)
  }
);}





export const getCuponsControllerCriarMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cuponsControllerCriar>>, TError,{data: CriarCupomDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof cuponsControllerCriar>>, TError,{data: CriarCupomDto}, TContext> => {

const mutationKey = ['cuponsControllerCriar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cuponsControllerCriar>>, {data: CriarCupomDto}> = (props) => {
          const {data} = props ?? {};

          return  cuponsControllerCriar(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CuponsControllerCriarMutationResult = NonNullable<Awaited<ReturnType<typeof cuponsControllerCriar>>>
    export type CuponsControllerCriarMutationBody = CriarCupomDto
    export type CuponsControllerCriarMutationError = ErroResponse

    /**
 * @summary Cria um cupom
 */
export const useCuponsControllerCriar = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cuponsControllerCriar>>, TError,{data: CriarCupomDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cuponsControllerCriar>>,
        TError,
        {data: CriarCupomDto},
        TContext
      > => {
      return useMutation(getCuponsControllerCriarMutationOptions(options), queryClient);
    }
    export const getCuponsControllerObterUrl = (id: string,) => {




  return `/v1/admin/cupons/${id}`
}

/**
 * @summary Detalha o cupom. ÚNICA rota da API que devolve `regras`.
 */
export const cuponsControllerObter = async (id: string, options?: Parameters<typeof httpClient>[1]): Promise<CupomDetalheResponse> => {

  return httpClient<CupomDetalheResponse>(getCuponsControllerObterUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getCuponsControllerObterQueryKey = (id: string,) => {
    return [
    `/v1/admin/cupons/${id}`
    ] as const;
    }


export const getCuponsControllerObterQueryOptions = <TData = Awaited<ReturnType<typeof cuponsControllerObter>>, TError = ErroResponse>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cuponsControllerObter>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCuponsControllerObterQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof cuponsControllerObter>>> = ({ signal }) => cuponsControllerObter(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof cuponsControllerObter>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CuponsControllerObterQueryResult = NonNullable<Awaited<ReturnType<typeof cuponsControllerObter>>>
export type CuponsControllerObterQueryError = ErroResponse


export function useCuponsControllerObter<TData = Awaited<ReturnType<typeof cuponsControllerObter>>, TError = ErroResponse>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof cuponsControllerObter>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof cuponsControllerObter>>,
          TError,
          Awaited<ReturnType<typeof cuponsControllerObter>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCuponsControllerObter<TData = Awaited<ReturnType<typeof cuponsControllerObter>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cuponsControllerObter>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof cuponsControllerObter>>,
          TError,
          Awaited<ReturnType<typeof cuponsControllerObter>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCuponsControllerObter<TData = Awaited<ReturnType<typeof cuponsControllerObter>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cuponsControllerObter>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Detalha o cupom. ÚNICA rota da API que devolve `regras`.
 */

export function useCuponsControllerObter<TData = Awaited<ReturnType<typeof cuponsControllerObter>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cuponsControllerObter>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCuponsControllerObterQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCuponsControllerAtualizarUrl = (id: string,) => {




  return `/v1/admin/cupons/${id}`
}

/**
 * @summary Atualiza o cupom. Omitir `regras` mantém o texto atual.
 */
export const cuponsControllerAtualizar = async (id: string,
    atualizarCupomDto: AtualizarCupomDto, options?: Parameters<typeof httpClient>[1]): Promise<CupomResponse> => {

  return httpClient<CupomResponse>(getCuponsControllerAtualizarUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(atualizarCupomDto)
  }
);}





export const getCuponsControllerAtualizarMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cuponsControllerAtualizar>>, TError,{id: string;data: AtualizarCupomDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof cuponsControllerAtualizar>>, TError,{id: string;data: AtualizarCupomDto}, TContext> => {

const mutationKey = ['cuponsControllerAtualizar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cuponsControllerAtualizar>>, {id: string;data: AtualizarCupomDto}> = (props) => {
          const {id,data} = props ?? {};

          return  cuponsControllerAtualizar(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CuponsControllerAtualizarMutationResult = NonNullable<Awaited<ReturnType<typeof cuponsControllerAtualizar>>>
    export type CuponsControllerAtualizarMutationBody = AtualizarCupomDto
    export type CuponsControllerAtualizarMutationError = unknown

    /**
 * @summary Atualiza o cupom. Omitir `regras` mantém o texto atual.
 */
export const useCuponsControllerAtualizar = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cuponsControllerAtualizar>>, TError,{id: string;data: AtualizarCupomDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cuponsControllerAtualizar>>,
        TError,
        {id: string;data: AtualizarCupomDto},
        TContext
      > => {
      return useMutation(getCuponsControllerAtualizarMutationOptions(options), queryClient);
    }
    export const getCuponsControllerDefinirAtivoUrl = (id: string,) => {




  return `/v1/admin/cupons/${id}/ativo`
}

/**
 * @summary Ativa ou desativa. É o "excluir" — o resgate é histórico.
 */
export const cuponsControllerDefinirAtivo = async (id: string,
    definirAtivoCupomDto: DefinirAtivoCupomDto, options?: Parameters<typeof httpClient>[1]): Promise<CupomResponse> => {

  return httpClient<CupomResponse>(getCuponsControllerDefinirAtivoUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(definirAtivoCupomDto)
  }
);}





export const getCuponsControllerDefinirAtivoMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cuponsControllerDefinirAtivo>>, TError,{id: string;data: DefinirAtivoCupomDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof cuponsControllerDefinirAtivo>>, TError,{id: string;data: DefinirAtivoCupomDto}, TContext> => {

const mutationKey = ['cuponsControllerDefinirAtivo'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cuponsControllerDefinirAtivo>>, {id: string;data: DefinirAtivoCupomDto}> = (props) => {
          const {id,data} = props ?? {};

          return  cuponsControllerDefinirAtivo(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CuponsControllerDefinirAtivoMutationResult = NonNullable<Awaited<ReturnType<typeof cuponsControllerDefinirAtivo>>>
    export type CuponsControllerDefinirAtivoMutationBody = DefinirAtivoCupomDto
    export type CuponsControllerDefinirAtivoMutationError = ErroResponse

    /**
 * @summary Ativa ou desativa. É o "excluir" — o resgate é histórico.
 */
export const useCuponsControllerDefinirAtivo = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cuponsControllerDefinirAtivo>>, TError,{id: string;data: DefinirAtivoCupomDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cuponsControllerDefinirAtivo>>,
        TError,
        {id: string;data: DefinirAtivoCupomDto},
        TContext
      > => {
      return useMutation(getCuponsControllerDefinirAtivoMutationOptions(options), queryClient);
    }
    export const getCuponsControllerEnviarImagemUrl = (id: string,) => {




  return `/v1/admin/cupons/${id}/imagem`
}

/**
 * @summary Envia a imagem do card. Exige proporção 3:1 (ex.: 1200×400).
 */
export const cuponsControllerEnviarImagem = async (id: string,
    cuponsControllerEnviarImagemBody: CuponsControllerEnviarImagemBody, options?: Parameters<typeof httpClient>[1]): Promise<CupomResponse> => {
    const formData = new FormData();
formData.append(`arquivo`, cuponsControllerEnviarImagemBody.arquivo);

  return httpClient<CupomResponse>(getCuponsControllerEnviarImagemUrl(id),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}





export const getCuponsControllerEnviarImagemMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cuponsControllerEnviarImagem>>, TError,{id: string;data: CuponsControllerEnviarImagemBody}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof cuponsControllerEnviarImagem>>, TError,{id: string;data: CuponsControllerEnviarImagemBody}, TContext> => {

const mutationKey = ['cuponsControllerEnviarImagem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cuponsControllerEnviarImagem>>, {id: string;data: CuponsControllerEnviarImagemBody}> = (props) => {
          const {id,data} = props ?? {};

          return  cuponsControllerEnviarImagem(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CuponsControllerEnviarImagemMutationResult = NonNullable<Awaited<ReturnType<typeof cuponsControllerEnviarImagem>>>
    export type CuponsControllerEnviarImagemMutationBody = CuponsControllerEnviarImagemBody
    export type CuponsControllerEnviarImagemMutationError = ErroResponse

    /**
 * @summary Envia a imagem do card. Exige proporção 3:1 (ex.: 1200×400).
 */
export const useCuponsControllerEnviarImagem = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cuponsControllerEnviarImagem>>, TError,{id: string;data: CuponsControllerEnviarImagemBody}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cuponsControllerEnviarImagem>>,
        TError,
        {id: string;data: CuponsControllerEnviarImagemBody},
        TContext
      > => {
      return useMutation(getCuponsControllerEnviarImagemMutationOptions(options), queryClient);
    }
